import React, { useState } from "react";
import "./Alert.scss";

const Alert = ({
  children,
  variant = "success",
  closable = false,
  actionLabel,
  onAction,
  onClose,
  className = "",
}) => {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  const classes = ["tx-alert", `tx-alert--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} role="alert">
      <span className="tx-alert__message">{children}</span>

      {actionLabel && (
        <button
          type="button"
          className="tx-alert__action"
          onClick={onAction}
        >
          {actionLabel}
        </button>
      )}

      {closable && (
        <button
          type="button"
          className="tx-alert__close"
          aria-label="Fechar alerta"
          onClick={handleClose}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M1 1L13 13M13 1L1 13"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Alert;
